<template>
  <div class="display-tickets-wrapper">
    <div v-if="!items.length" class="skeleton-wrapper">
      <van-skeleton title :row="7" />
    </div>
    <div v-else>
      <div class="tabs-wrapper">
        <van-tabs v-model="active" :ellipsis="false" :border="false">
          <van-tab
            v-for="item of items"
            :key="item.id"
            :title="item.title"
            :name="item.id"
          ></van-tab>
        </van-tabs>
      </div>
      <div class="tickets-wrapper">
        <display-ticket-item
          v-for="item of tickets"
          :key="item.id"
          :value="item"
          @purchase="handlePurchase"
        />
      </div>
    </div>
  </div>
</template>
<script>
import DisplayTicketItem from './DisplayTicketItem.vue';

export default {
  components: {
    DisplayTicketItem,
  },
  props: {
    items: [Array],
    type: [String],
  },
  data() {
    return {
      active: undefined,
    };
  },
  computed: {
    tickets() {
      const category = this.items.find(item => item.id === this.active);
      return category ? category.children : [];
    },
  },
  methods: {
    handlePurchase(id) {
      if (this.type) {
        this.$router.push({ name: 'venue_ticket_detail', query: { id } });
      } else {
        this.$router.push({ name: 'ticket_detail', query: { id } });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.display-tickets-wrapper {
  background: #fff;

  .skeleton-wrapper {
    padding-top: 16px;
  }
  .tabs-wrapper {
    /deep/ .van-tabs--line {
      border-bottom: 1px solid rgba(114, 119, 123, 0.1);
      /deep/ .van-tabs__wrap {
        height: 40px;
        /deep/ .van-tabs__nav {
          background: #fff;
        }
        /deep/ .van-tabs__nav--line {
          height: 40px;
          margin: auto;
          border: none;
          // border-radius: 10px 10px 0 0;
          /deep/ .van-tabs__line {
            background: #45b97c;
          }
          /deep/ .van-tab {
            color: #7d7e80;
            text-align: center;
            // font-weight: 600;
            border: none;
            background: #fff;
            line-height: 40px;
            display: inline-block;
          }
          /deep/ .van-tab--active {
            color: #45b97c;
            // font-weight: 600;
            background-color: #fff;
          }
          /deep/ .van-ellipsis {
            // overflow: auto;
            // text-overflow: clip;
          }
        }
      }
    }
  }
}
</style>
